import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';

export default {
    /**
     * @param  {function} commit
     * @param  {function} dispatch
     * @param  {string} keyword
     */
    updateKeyword({ commit, dispatch }, keyword) {
        commit('updateKeyword', keyword);
        // Reset page count when changing keyword
        commit('resetPageCount');
        commit('resetFacetsAndType');
        dispatch('performSearch', true);
    },
    /**
     * Get initial set of facets before first meaningful search
     * @param  {function} commit
     * @param  {object} payload
     * @return {Promise}
     */
    getFacets({ commit }, payload) {
        return axios.get('/api/search', {
            params: {
                mode: payload.mode,
                keyword: payload.keyword,
            },
            paramsSerializer(parameters) {
                return qs.stringify(parameters, { arrayFormat: 'comma' });
            },
        }).then((response) => {
            commit('updateAvailableFacets', response.data.data);
            commit('updateAvailableTypes', response.data.data);
        }).catch((error) => {
            
        });

    },
    /**
     * @param  {function} commit     {description}
     * @param  {URLSerachParams} searchParams
     */
    setInitialState({ commit }, searchParams) {
        commit('setInitialState', searchParams);
    },
    /**
     * @param  {function} commit
     * @param  {function} dispatch
     * @param  {object} payload
     */
    replaceFacets({ commit, dispatch }, payload) {
        commit('replaceFacets', payload);
        dispatch('performSearch');
    },
    /**
     * @param  {function} commit
     * @param  {function} dispatch
     * @param  {object} payload
     */
    removeFacet({ commit, dispatch }, payload) {
        commit('removeFacet', payload);
        dispatch('performSearch');
    },
    /**
     * @param  {function} commit
     * @param  {function} dispatch
     */
    clearFacets({ commit, dispatch }) {
        commit('clearFacets');
        dispatch('performSearch');
    },
    /**
     * @param  {function} commit
     * @param  {function} dispatch
     * @param  {object} payload
     */
    updateTypes({ commit, dispatch }, payload) {
        commit('updateTypes', payload);
        commit('resetPageCount');
        dispatch('performSearch');
    },
    goToPage({ commit, dispatch }, page) {
        commit('goToPage', page);
        dispatch('performSearch');
    },
    /**
     * @param  {function} commit
     * @param  {string} mode
     */
    setMode({ commit }, mode) {
        commit('setMode', mode);
    },
    /**
     * @param {function} commit
     * @param {function} dispatch
     * @param {object} payload
     */
    toggleShowSaved({ commit, dispatch }, payload) {
        commit('toggleShowSaved', payload);
        dispatch('performSearch');
    },
    /**
     * Performs a search against the elasticsearch api
     * @param {function} commit
     * @param {object} getters,
     * @param {object} state
     * @param {function} dispatch
     * @param {boolean} updateFacets {Whether to update the available facets}
     * @return {Promise}
     */
    performSearch(
        {
            commit,
            getters,
            state,
            dispatch,
        },
        updateFacets = false,
    ) {
        let params = getters.searchParams;
        commit('setIsSearching', true);
        commit('clearSearchError');

        // Update the url search params if this is not the initial load
        // (i.e.) Not the initial search query to fetch facets
        if (!state.isLoading) {
            dispatch('updateHistoryState', params);
        }

        // If a mode is being forced,
        // append it to params
        if (state.mode) {
            params = {
                ...params,
                mode: state.mode,
            };
        }

        return axios.get('/api/search', {
            params,
            paramsSerializer(parameters) {
                return qs.stringify(parameters, { arrayFormat: 'comma' });
            },
        }).then((response) => {
            commit('updateResults', {
                ...response.data.data,
            });

            if (updateFacets) {
                commit('updateAvailableFacets', response.data.data);
                commit('updateAvailableTypes', response.data.data);
            }
        }).catch((error) => {
            commit('setSearchError', 'An error has occurred. Please try your request again later.');
        }).finally(() => {
            commit('setIsSearching', false);
            /**
             * Toggle loading state off if this is the initial search
             */
            if (state.isLoading) {
                commit('toggleLoading');
            }
        });
    },
    /**
     * Update the url search state based on the current search parameters
     * @param  {function} context {description}
     * @param  {function} dispatch {description}
     * @param  {object} params  The current search params from getters.searchParams
     */
    updateHistoryState({ context, dispatch }, params) {
        const searchParams = new URLSearchParams(params);
        let newRelativePathQuery;
        if (Array.from(searchParams).length) {
            newRelativePathQuery = `${window.location.pathname}?${searchParams.toString()}`;
        } else {
            newRelativePathQuery = `${window.location.pathname}`;
        }
        window.history.replaceState(null, '', newRelativePathQuery);
        dispatch('logPageviewInAnalytics', newRelativePathQuery);
    },
    /**
     * Send a pageview over to google analytics
     */
    logPageviewInAnalytics({ context }, path) {
        Vue.$gtag.pageview({
            page_path: path
        });
    }
};
